<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Isabel’s Wedding</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<h1 class="book-title">ISABEL’S WEDDING</h1>
<h2 class="book-author">Pamela Oldfield</h2>
<p class="publisher-logo"><img alt="logo missing" height="51" src="images/logo.jpg" width="72"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?c9c8c078